module.exports = __webpack_public_path__ + "37ace656fd3e31f2ea14cd09ef9a483d.png";